const mediaData = [
  {
    id: "seoul-night-walk",
    title: "首尔夜行",
    originalTitle: "서울 야행",
    type: "movie",
    region: "韩国",
    year: 2025,
    genres: ["悬疑", "犯罪"],
    rating: 8.9,
    heat: 98,
    director: "朴叙镇",
    cast: ["李在勋", "金多恩", "郑河彬"],
    duration: "122分钟",
    episodes: "电影长片",
    status: "已上映",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20lone%20figure%20in%20a%20long%20coat%20walking%20through%20rain-soaked%20Seoul%20streets%20at%20midnight%2C%20neon%20signs%20reflecting%20on%20wet%20asphalt%2C%20deep%20navy%20blue%20shadows%20with%20warm%20amber%20highlights%2C%20mysterious%20noir%20atmosphere%2C%20subtle%20film%20grain%2C%20elegant%20minimal%20composition%20with%20empty%20space%20at%20top%2C%20highly%20detailed%2C%20no%20text&width=600&height=800&seq=rk-poster-01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20rainy%20Seoul%20alley%20at%20night%2C%20wet%20asphalt%20mirroring%20amber%20street%20lamps%20and%20distant%20neon%20signs%2C%20deep%20navy%20blue%20city%20silhouette%2C%20atmospheric%20haze%2C%20moody%20crime%20drama%20lighting%2C%20empty%20street%20with%20subtle%20depth%2C%20anamorphic%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=rk-backdrop-01&orientation=landscape",
    tagline: "一夜之间，整座城市的秘密都被点亮。",
    synopsis: "首尔一夜之间连续发生三起毫无关联的失踪案。出租车司机姜宇在一次夜班中载到一名神情恍惚的乘客，从此被卷入一场横跨整座城市的追踪。他必须在黎明前拼起碎片，而每一个目击者都在说谎。",
    highlights: ["第28届釜山国际电影节 新浪潮单元提名", "2025年度韩国票房前十", "亚洲电影大奖最佳摄影提名"],
    featured: true
  },
  {
    id: "rain-in-tokyo",
    title: "东京·雨停之后",
    originalTitle: "東京、雨が止んだあと",
    type: "movie",
    region: "日本",
    year: 2024,
    genres: ["爱情", "剧情"],
    rating: 8.7,
    heat: 92,
    director: "岩井澄",
    cast: ["小林遥", "松田悠真", "吉冈千夏"],
    duration: "118分钟",
    episodes: "电影长片",
    status: "已上映",
    cover: "https://readdy.ai/api/search-image?query=Gentle%20Japanese%20romance%20film%20poster%20artwork%2C%20two%20figures%20sharing%20one%20transparent%20umbrella%20on%20a%20quiet%20Tokyo%20backstreet%20after%20rain%2C%20soft%20warm%20sunset%20light%20through%20wet%20leaves%2C%20muted%20cream%20and%20deep%20indigo%20tones%2C%20delicate%20nostalgic%20mood%2C%20shallow%20depth%20of%20field%2C%20airy%20minimal%20composition%2C%20no%20text&width=600&height=800&seq=rk-poster-02&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Soft%20cinematic%20wide%20shot%20of%20a%20quiet%20Tokyo%20residential%20street%20after%20evening%20rain%2C%20warm%20amber%20window%20light%2C%20reflective%20pavement%2C%20gentle%20mist%2C%20muted%20indigo%20and%20cream%20color%20palette%2C%20tranquil%20romantic%20mood%2C%20delicate%20bokeh%2C%20no%20text&width=1600&height=900&seq=rk-backdrop-02&orientation=landscape",
    tagline: "有些告别，要等一场雨停下来才能说出口。",
    synopsis: "在东京做旧书修复的女孩遥，每逢下雨都会在同一座天桥下遇见他。两人从不说名字，只聊书和天气。直到雨季结束，她才意识到，对方一直在等她说出那句没能说出口的告别。",
    highlights: ["日本电影学院奖最佳女主角提名", "2024年度日本爱情片口碑榜第一", "东京国际电影节观众选择奖"],
    featured: true
  },
  {
    id: "deep-sea-daylight",
    title: "白昼的深海",
    originalTitle: "한낮의 심해",
    type: "movie",
    region: "韩国",
    year: 2025,
    genres: ["剧情", "家庭"],
    rating: 8.5,
    heat: 88,
    director: "尹智浩",
    cast: ["全慧珍", "朴素贤", "李道贤"],
    duration: "134分钟",
    episodes: "电影长片",
    status: "已上映",
    cover: "https://readdy.ai/api/search-image?query=Quiet%20Korean%20family%20drama%20poster%2C%20a%20mother%20and%20teenage%20daughter%20standing%20apart%20on%20a%20vast%20empty%20beach%20under%20overcast%20white%20sky%2C%20cold%20steel%20blue%20sea%2C%20single%20warm%20orange%20scarf%20as%20the%20only%20color%20accent%2C%20restrained%20melancholic%20mood%2C%20soft%20natural%20light%2C%20minimal%20composition%20with%20negative%20space%2C%20no%20text&width=600&height=800&seq=rk-poster-03&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20melancholic%20seascape%20under%20a%20pale%20overcast%20sky%2C%20calm%20steel%20blue%20water%2C%20fine%20white%20foam%2C%20distant%20lighthouse%20silhouette%2C%20cold%20navy%20tones%20with%20a%20faint%20amber%20horizon%20glow%2C%20meditative%20cinematic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=rk-backdrop-03&orientation=landscape",
    tagline: "她用了二十年，才学会游回岸边。",
    synopsis: "母亲在一场事故后失去了对声音的感知，女儿则用沉默回应整个世界。一次被迫同行的海岛之旅，让两人重新面对那件被埋藏了二十年的往事。这是一部关于原谅与自我和解的作品。",
    highlights: ["第60届百想艺术大赏 最佳影片提名", "全慧珍获年度最佳女主角", "釜山影评人协会奖最佳剧本"],
    featured: true
  },
  {
    id: "kyoto-lost",
    title: "京都迷途",
    originalTitle: "京都、迷い道",
    type: "movie",
    region: "日本",
    year: 2025,
    genres: ["悬疑", "剧情"],
    rating: 8.8,
    heat: 90,
    director: "高桥岭",
    cast: ["仲村透", "藤井纱良", "大西圭"],
    duration: "126分钟",
    episodes: "电影长片",
    status: "已上映",
    cover: "https://readdy.ai/api/search-image?query=Mysterious%20Japanese%20film%20poster%20of%20an%20empty%20stone%20path%20through%20a%20Kyoto%20bamboo%20grove%20at%20dusk%2C%20a%20single%20red%20paper%20lantern%20glowing%2C%20deep%20indigo%20shadows%2C%20mist%20between%20trees%2C%20a%20distant%20woman%20figure%20in%20a%20pale%20kimono%2C%20elegant%20suspense%20atmosphere%2C%20fine%20film%20grain%2C%20vertical%20composition%2C%20no%20text&width=600&height=800&seq=rk-poster-04&orientation=portrait",
    tagline: "地图上没有的那条路，通向谁的记忆？",
    synopsis: "一位整理古地图的学者在京都旧宅里发现一张不存在的小路手绘图。循着图上的标记，他走进城市被遗忘的巷弄，也走进了三位陌生人的共同记忆。真相近在眼前，却每一步都像迷途。",
    highlights: ["釜山国际电影节 亚洲之窗单元展映", "日本电影学院奖最佳摄影", "年度日式悬疑口碑之作"]
  },
  {
    id: "headwind-37",
    title: "逆风三十七度",
    originalTitle: "역풍 37도",
    type: "movie",
    region: "韩国",
    year: 2023,
    genres: ["动作", "犯罪"],
    rating: 7.9,
    heat: 84,
    director: "姜泰武",
    cast: ["车胜元", "朴海俊", "徐智慧"],
    duration: "117分钟",
    episodes: "电影长片",
    status: "已上映",
    cover: "https://readdy.ai/api/search-image?query=High%20contrast%20Korean%20action%20film%20poster%2C%20a%20determined%20man%20in%20a%20windbreaker%20standing%20on%20a%20windy%20harbor%20rooftop%2C%20storm%20clouds%20and%20orange%20safety%20lights%2C%20cold%20navy%20blue%20grading%2C%20cinematic%20motion%20blur%20on%20his%20coat%2C%20gritty%20crime%20thriller%20mood%2C%20strong%20silhouette%2C%20dramatic%20backlight%2C%20no%20text&width=600&height=800&seq=rk-poster-05&orientation=portrait",
    tagline: "风往哪儿吹，他偏往哪儿走。",
    synopsis: "被停职的缉私警探为了替搭档翻案，独自追查一条横跨港口的走私链。三十七度是那年夏天最热的一天，也是他最后一次相信规则的日子。",
    highlights: ["韩国动作电影奖 最佳动作设计", "2023年暑期档票房黑马", "车胜元高难度实拍动作场面"]
  },
  {
    id: "summer-konbini",
    title: "夏日便利屋",
    originalTitle: "夏のコンビニ",
    type: "movie",
    region: "日本",
    year: 2024,
    genres: ["治愈", "喜剧"],
    rating: 8.2,
    heat: 86,
    director: "小林和也",
    cast: ["山崎葵", "洼田亮", "吉田南"],
    duration: "108分钟",
    episodes: "电影长片",
    status: "已上映",
    cover: "https://readdy.ai/api/search-image?query=Warm%20Japanese%20slice%20of%20life%20poster%2C%20a%20small%20seaside%20convenience%20store%20glowing%20at%20blue%20hour%2C%20cicadas%20and%20potted%20plants%20outside%2C%20a%20young%20clerk%20sweeping%20the%20doorway%2C%20warm%20orange%20interior%20light%20against%20soft%20navy%20twilight%2C%20nostalgic%20summer%20mood%2C%20gentle%20film%20photography%20texture%2C%20no%20text&width=600&height=800&seq=rk-poster-06&orientation=portrait",
    tagline: "这个夏天，便利店替你把烦恼冰起来了。",
    synopsis: "海边小镇唯一一家便利店，只在夏天营业。店主是个话不多的中年人，店员是三个各有心事的年轻人。整个夏天，他们卖出的不只是冰棍和关东煮，还有一点点重新开始的勇气。",
    highlights: ["日本每日电影奖 最佳新人导演", "年度治愈系电影推荐榜", "取景地成为夏季热门旅行路线"]
  },
  {
    id: "silent-testimony",
    title: "无声证词",
    originalTitle: "침묵의 증언",
    type: "movie",
    region: "韩国",
    year: 2024,
    genres: ["犯罪", "悬疑"],
    rating: 8.6,
    heat: 87,
    director: "金哉勋",
    cast: ["韩素妍", "刘镇宇", "白承浩"],
    duration: "124分钟",
    episodes: "电影长片",
    status: "已上映",
    cover: "https://readdy.ai/api/search-image?query=Korean%20crime%20thriller%20poster%2C%20close%20portrait%20of%20a%20female%20sign%20language%20interpreter%20in%20a%20dark%20courtroom%2C%20half%20of%20her%20face%20lit%20by%20cold%20blue%20window%20light%2C%20warm%20amber%20desk%20lamp%20in%20the%20background%2C%20tense%20investigative%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20elegant%20minimal%20layout%2C%20no%20text&width=600&height=800&seq=rk-poster-07&orientation=portrait",
    tagline: "当所有人都在说话，只有她在听。",
    synopsis: "一名手语翻译被临时请进法庭，为唯一的目击者做翻译。她却逐渐发现，对方比划出的证词与检方记录完全不同。在一桩看似板上钉钉的案件里，沉默成了最危险的证据。",
    highlights: ["第45届青龙电影奖 最佳女主角提名", "年度韩国悬疑片评分前三", "剧本获韩国电影振兴委员会年度扶持"]
  },
  {
    id: "galaxy-platform",
    title: "银河站台",
    originalTitle: "銀河プラットフォーム",
    type: "movie",
    region: "日本",
    year: 2025,
    genres: ["科幻", "爱情"],
    rating: 8.4,
    heat: 83,
    director: "佐藤光",
    cast: ["森川葵", "赤楚航", "小野真央"],
    duration: "131分钟",
    episodes: "电影长片",
    status: "已上映",
    cover: "https://readdy.ai/api/search-image?query=Dreamy%20Japanese%20science%20fiction%20poster%2C%20an%20empty%20rural%20train%20platform%20floating%20in%20a%20starry%20indigo%20sky%2C%20one%20warm%20orange%20station%20lamp%2C%20a%20young%20woman%20holding%20a%20paper%20ticket%2C%20reflective%20wet%20ground%2C%20soft%20nebula%20glow%2C%20romantic%20wonder%2C%20cinematic%20wide%20negative%20space%2C%20no%20text&width=600&height=800&seq=rk-poster-08&orientation=portrait",
    tagline: "末班车开往的，是你还没经历过的昨天。",
    synopsis: "小镇站台每晚零点会多出一班没有编号的列车。女孩真央在等一个再也不会回来的人，却等来了一位自称来自三年后的旅客。他们约定只用一张车票的时间相爱。",
    highlights: ["日本科幻大奖 最佳影片", "年度最美摄影提名", "原创配乐获亚洲电影音乐奖"]
  },
  {
    id: "seaside-vinyl",
    title: "海边的旧唱片",
    originalTitle: "海辺のレコード",
    type: "movie",
    region: "日本",
    year: 2023,
    genres: ["剧情", "音乐"],
    rating: 8.0,
    heat: 78,
    director: "大森菜月",
    cast: ["松冈茉优", "加藤谅", "平田遥"],
    duration: "112分钟",
    episodes: "电影长片",
    status: "已上映",
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20Japanese%20drama%20poster%2C%20an%20old%20vinyl%20record%20spinning%20on%20a%20wooden%20turntable%20by%20a%20seaside%20window%2C%20warm%20late%20afternoon%20sunlight%2C%20dust%20motes%20in%20the%20air%2C%20deep%20teal%20ocean%20visible%20outside%2C%20amber%20toned%20interior%2C%20tender%20melancholic%20mood%2C%20film%20photography%20texture%2C%20no%20text&width=600&height=800&seq=rk-poster-09&orientation=portrait",
    tagline: "有些声音，只属于那个夏天。",
    synopsis: "辞掉东京工作的女孩回到海边老家，整理已故父亲留下的唱片店。在一张没有标签的黑胶里，她听见了父亲年轻时的声音，也听见了一段从未被讲述的家庭往事。",
    highlights: ["日本电影旬报年度十佳", "最佳原创歌曲提名", "海边小镇实景拍摄"]
  },
  {
    id: "north-of-han",
    title: "汉江以北",
    originalTitle: "한강 이북",
    type: "tv",
    region: "韩国",
    year: 2025,
    genres: ["犯罪", "剧情"],
    rating: 9.1,
    heat: 97,
    director: "文承浩",
    cast: ["姜河俊", "林世娜", "吴道镇"],
    duration: "单集60分钟",
    episodes: "全16集",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Gritty%20Korean%20crime%20series%20poster%2C%20a%20detective%20standing%20on%20a%20bridge%20over%20the%20Han%20River%20at%20night%2C%20city%20lights%20dissolving%20into%20deep%20navy%20fog%2C%20warm%20orange%20streetlamp%20rim%20light%2C%20rain%20on%20his%20shoulders%2C%20tense%20atmospheric%20mood%2C%20cinematic%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=rk-poster-10&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Panoramic%20night%20view%20of%20the%20Han%20River%20in%20Seoul%20with%20heavy%20mist%2C%20distant%20city%20lights%20blurred%20into%20amber%20bokeh%2C%20deep%20navy%20blue%20water%2C%20bridge%20silhouette%2C%20tense%20police%20procedural%20atmosphere%2C%20cinematic%20wide%20composition%2C%20subtle%20rain%20streaks%2C%20no%20text&width=1600&height=900&seq=rk-backdrop-10&orientation=landscape",
    tagline: "这条江把城市分成两半，也把真相分成两半。",
    synopsis: "汉江以北的老城区接连出现匿名举报信，每一封都精准指向一桩被结案的旧案。重案组组长姜河俊与新人检察官林世娜被迫联手，在市政重建计划的阴影下追查一条盘踞二十年的关系链。",
    highlights: ["2025年韩剧话题度连续八周第一", "百想艺术大赏 电视剧部门最佳作品提名", "韩国放送评论奖最佳剧本"],
    featured: true
  },
  {
    id: "spring-notes",
    title: "春日记事",
    originalTitle: "봄의 기록",
    type: "tv",
    region: "韩国",
    year: 2024,
    genres: ["爱情", "治愈"],
    rating: 8.6,
    heat: 89,
    director: "徐允儿",
    cast: ["朴敏书", "金泰晤", "郑多恩"],
    duration: "单集65分钟",
    episodes: "全12集",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Soft%20Korean%20romance%20series%20poster%2C%20a%20young%20woman%20writing%20in%20a%20notebook%20at%20a%20cafe%20window%20filled%20with%20cherry%20blossoms%2C%20warm%20spring%20sunlight%2C%20cream%20and%20pale%20rose%20tones%20with%20deep%20navy%20accents%2C%20gentle%20breeze%20moving%20curtains%2C%20tender%20hopeful%20mood%2C%20airy%20minimal%20composition%2C%20no%20text&width=600&height=800&seq=rk-poster-11&orientation=portrait",
    tagline: "春天会来，迟到的人也会。",
    synopsis: "在小城图书馆工作的敏书，负责整理一批无人认领的旧信件。她按地址去找写信人，却遇见了刚回乡开修表店的泰晤。两个都不擅长表达的人，用一整个春天学会了开口。",
    highlights: ["2024年韩国爱情剧评分榜第二", "最佳情侣奖", "原声带进入年度榜单前十"]
  },
  {
    id: "tsukimi-diner",
    title: "月见食堂",
    originalTitle: "月見食堂",
    type: "tv",
    region: "日本",
    year: 2024,
    genres: ["治愈", "美食"],
    rating: 8.8,
    heat: 90,
    director: "高木凉",
    cast: ["绪形圭", "竹内绿", "坂本悠"],
    duration: "单集45分钟",
    episodes: "全10集",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20Japanese%20food%20drama%20poster%2C%20a%20tiny%20late-night%20diner%20with%20a%20warm%20paper%20lantern%2C%20steam%20rising%20from%20a%20bowl%20of%20noodles%2C%20a%20kind%20older%20chef%20behind%20the%20counter%2C%20deep%20navy%20night%20outside%2C%20amber%20interior%20glow%2C%20intimate%20nostalgic%20mood%2C%20soft%20film%20texture%2C%20no%20text&width=600&height=800&seq=rk-poster-12&orientation=portrait",
    tagline: "凌晨一点，菜单上只有你想吃的那道菜。",
    synopsis: "东京巷子深处有一家只在深夜营业的小食堂。老板不多话，却总能做出客人当下最需要的那道菜。每一集，一位带着心事的客人推门而入，吃饱之后，把难题留在了门外。",
    highlights: ["2024年日本治愈剧口碑第一", "美食场景实拍无替身", "东京观光局推荐取景地"]
  },
  {
    id: "seventh-witness",
    title: "第七位证人",
    originalTitle: "일곱 번째 목격자",
    type: "tv",
    region: "韩国",
    year: 2025,
    genres: ["悬疑", "犯罪"],
    rating: 9.0,
    heat: 95,
    director: "申宇哲",
    cast: ["徐恩彩", "权道允", "河俊浩"],
    duration: "单集62分钟",
    episodes: "全14集",
    status: "更新至第12集",
    cover: "https://readdy.ai/api/search-image?query=Dark%20Korean%20mystery%20series%20poster%2C%20six%20empty%20interrogation%20chairs%20in%20a%20dim%20room%20and%20one%20lit%20chair%20in%20the%20foreground%2C%20cold%20blue%20overhead%20light%2C%20a%20single%20warm%20orange%20lamp%2C%20long%20shadows%20on%20concrete%20walls%2C%20unsettling%20quiet%20tension%2C%20symmetrical%20composition%2C%20no%20text&width=600&height=800&seq=rk-poster-13&orientation=portrait",
    tagline: "六个人指认了他，只有第七个人说他没有。",
    synopsis: "一桩少年失踪案在十年后重启，六位证人的口供几乎完全一致。唯独当年未被记录的第七位证人突然现身，她的记忆与所有人相反。刑警与心理侧写师必须在谎言里找出那个被刻意删掉的人。",
    highlights: ["2025年悬疑剧集热度榜第一", "韩国 Contents 大奖最佳导演", "单集最高收视率 12.4%"]
  },
  {
    id: "tokyo-sharehouse",
    title: "东京合租日记",
    originalTitle: "東京シェア日記",
    type: "tv",
    region: "日本",
    year: 2025,
    genres: ["青春", "喜剧"],
    rating: 8.3,
    heat: 85,
    director: "田中ひかり",
    cast: ["野村美咲", "石井莲", "中川优"],
    duration: "单集30分钟",
    episodes: "全11集",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Bright%20Japanese%20youth%20comedy%20series%20poster%2C%20four%20young%20roommates%20crowded%20around%20a%20small%20Tokyo%20apartment%20kitchen%2C%20morning%20sunlight%20through%20thin%20curtains%2C%20mismatched%20mugs%20and%20plants%2C%20warm%20cream%20and%20soft%20navy%20palette%2C%20playful%20chaotic%20energy%2C%20candid%20photography%20feel%2C%20no%20text&width=600&height=800&seq=rk-poster-14&orientation=portrait",
    tagline: "四个陌生人，一间老房子，一整个乱七八糟的青春。",
    synopsis: "为了省房租，四个性格完全不同的年轻人住进了东京一间老公寓。从抢浴室到替彼此应付家长，他们用最笨的方式学会了如何和人生活在一起。",
    highlights: ["2025年春季日剧满意度第一", "最佳喜剧剧本提名", "社交平台二创话题破百万"]
  },
  {
    id: "shadow-of-throne",
    title: "王座之影",
    originalTitle: "왕좌의 그림자",
    type: "tv",
    region: "韩国",
    year: 2024,
    genres: ["古装", "剧情"],
    rating: 8.9,
    heat: 91,
    director: "崔成勋",
    cast: ["韩智焕", "闵彩英", "申东延"],
    duration: "单集70分钟",
    episodes: "全20集",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Epic%20Korean%20historical%20drama%20poster%2C%20a%20crowned%20figure%20seen%20from%20behind%20in%20a%20vast%20dark%20palace%20hall%2C%20red%20and%20amber%20lantern%20light%2C%20deep%20navy%20shadows%2C%20intricate%20traditional%20patterns%2C%20a%20single%20golden%20throne%20at%20the%20end%20of%20the%20corridor%2C%20dramatic%20symmetrical%20composition%2C%20rich%20textured%20costume%20detail%2C%20no%20text&width=600&height=800&seq=rk-poster-15&orientation=portrait",
    tagline: "坐上王座的人，先要学会成为影子。",
    synopsis: "少年君主在权臣环伺中继位，唯一能信任的是被贬为宫女的旧日伴读。朝堂之上没有永远的朋友，只有不断改写的忠诚。一部关于权力、代价与选择的古装群像剧。",
    highlights: ["2024年韩国古装剧评分第一", "百想艺术大赏 最佳美术", "海外版权售出至 42 个国家"]
  },
  {
    id: "blue-emergency",
    title: "蓝色急诊室",
    originalTitle: "青い救急室",
    type: "tv",
    region: "日本",
    year: 2024,
    genres: ["职场", "剧情"],
    rating: 8.4,
    heat: 86,
    director: "渡边翔",
    cast: ["樱井遥", "村上慧", "小坂真琴"],
    duration: "单集55分钟",
    episodes: "全12集",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20medical%20drama%20poster%2C%20a%20young%20female%20emergency%20doctor%20pulling%20off%20surgical%20gloves%20in%20a%20bright%20hospital%20corridor%2C%20cool%20blue%20fluorescent%20light%20mixed%20with%20warm%20amber%20sunset%20through%20windows%2C%20exhausted%20but%20determined%20expression%2C%20clean%20clinical%20composition%2C%20no%20text&width=600&height=800&seq=rk-poster-16&orientation=portrait",
    tagline: "每一秒都在决定，谁可以继续活下去。",
    synopsis: "新调任的急诊科医生樱井遥以冷静著称，却总在深夜独自复盘每一个没能救回来的病人。面对人手短缺与制度压力，她必须第一次承认，医生也会害怕。",
    highlights: ["2024年日剧医疗题材口碑最佳", "最佳女主角提名", "医学顾问全程现场指导"]
  },
  {
    id: "our-unfinished-summer",
    title: "我们的夏天未完",
    originalTitle: "우리의 여름은 아직",
    type: "tv",
    region: "韩国",
    year: 2023,
    genres: ["青春", "爱情"],
    rating: 8.1,
    heat: 82,
    director: "金多率",
    cast: ["李秀彬", "郑在民", "孔敏智"],
    duration: "单集60分钟",
    episodes: "全16集",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20Korean%20coming%20of%20age%20poster%2C%20two%20teenagers%20sitting%20on%20a%20school%20rooftop%20at%20golden%20hour%2C%20uniforms%20and%20bicycles%2C%20warm%20amber%20sky%20fading%20into%20deep%20navy%2C%20summer%20heat%20haze%2C%20a%20distant%20Ferris%20wheel%2C%20bittersweet%20youthful%20mood%2C%20soft%20film%20grain%2C%20no%20text&width=600&height=800&seq=rk-poster-17&orientation=portrait",
    tagline: "那年夏天没有结局，所以我们一直没长大。",
    synopsis: "高三最后一个暑假，五个朋友约定十年后在同一个海边见面。有人先离开了小镇，有人留了下来。十年后的重逢，把那个没说完的夏天重新翻开。",
    highlights: ["2023年韩国青春剧话题之作", "新人演员奖", "原声带《未完的夏天》年度热播"]
  },
  {
    id: "latitude-35",
    title: "北纬三十五度",
    originalTitle: "北緯三十五度",
    type: "tv",
    region: "日本",
    year: 2025,
    genres: ["悬疑", "科幻"],
    rating: 8.7,
    heat: 88,
    director: "石井聪",
    cast: ["长谷川凛", "松本圭", "青山透"],
    duration: "单集50分钟",
    episodes: "全10集",
    status: "更新至第9集",
    cover: "https://readdy.ai/api/search-image?query=Atmospheric%20Japanese%20science%20fiction%20series%20poster%2C%20a%20coastal%20observatory%20on%20a%20cliff%20at%20night%2C%20a%20giant%20radio%20telescope%20silhouette%20against%20a%20star-filled%20indigo%20sky%2C%20a%20single%20warm%20amber%20window%2C%20faint%20green%20aurora%20on%20the%20horizon%2C%20quiet%20mysterious%20tension%2C%20cinematic%20vertical%20composition%2C%20no%20text&width=600&height=800&seq=rk-poster-18&orientation=portrait",
    tagline: "同一条纬线上，时间出现了两次。",
    synopsis: "海边天文台的观测员接收到一段来自北纬三十五度的重复信号，而信号内容正是她三天后要说的话。随着异常扩大，小镇上的人开始记起尚未发生的事。",
    highlights: ["2025年日本悬疑新剧收视冠军", "最佳视觉效果提名", "原创概念获科幻评论界关注"]
  },
  {
    id: "three-meals-jeju",
    title: "三食三餐·济州篇",
    originalTitle: "삼시세끼 제주",
    type: "variety",
    region: "韩国",
    year: 2025,
    genres: ["真人秀", "治愈"],
    rating: 8.8,
    heat: 90,
    director: "韩东延",
    cast: ["姜宇", "李度妍", "朴成洙"],
    duration: "单期95分钟",
    episodes: "全12期",
    status: "更新至第10期",
    cover: "https://readdy.ai/api/search-image?query=Warm%20Korean%20cooking%20variety%20show%20poster%2C%20three%20friends%20preparing%20a%20rustic%20meal%20on%20a%20stone%20terrace%20in%20Jeju%2C%20tangerine%20trees%20and%20black%20volcanic%20rocks%2C%20soft%20afternoon%20sunlight%2C%20steaming%20pots%20and%20fresh%20greens%2C%20deep%20navy%20sea%20in%20the%20distance%2C%20cozy%20authentic%20mood%2C%20no%20text&width=600&height=800&seq=rk-poster-19&orientation=portrait",
    tagline: "在济州，一天只做三件事：做饭、吃饭、看海。",
    synopsis: "三位老友在济州岛租下一间石屋，自己种菜、赶海、生火做饭。没有任务，没有比赛，只有一日三餐和慢慢变长的黄昏。",
    highlights: ["2025年韩国综艺话题榜第一", "治愈类综艺最高评分", "济州当地食材特辑获好评"]
  },
  {
    id: "tokyo-24h",
    title: "东京漫游二十四小时",
    originalTitle: "東京24時間",
    type: "variety",
    region: "日本",
    year: 2025,
    genres: ["旅行", "纪实"],
    rating: 8.5,
    heat: 84,
    director: "坂口健",
    cast: ["松田悠", "小林夏美", "藤原树"],
    duration: "单期70分钟",
    episodes: "全8期",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20travel%20documentary%20poster%2C%20a%20narrow%20Tokyo%20alley%20at%20blue%20hour%20with%20tiny%20bars%20and%20paper%20lanterns%2C%20a%20lone%20cyclist%20passing%2C%20wet%20cobblestones%20reflecting%20warm%20amber%20light%2C%20deep%20navy%20sky%2C%20quiet%20observational%20mood%2C%20documentary%20photography%20texture%2C%20no%20text&width=600&height=800&seq=rk-poster-20&orientation=portrait",
    tagline: "给一座城市二十四小时，它会告诉你自己的故事。",
    synopsis: "摄制组不做攻略、不设剧本，只跟着时间走。从清晨的筑地到深夜的居酒屋，记录东京一整天里最普通的二十四小时。",
    highlights: ["日本纪行节目年度推荐", "最佳摄影（综艺部门）", "深夜档收视口碑双高"]
  },
  {
    id: "idol-practice-room",
    title: "偶像练习室",
    originalTitle: "아이돌 연습실",
    type: "variety",
    region: "韩国",
    year: 2024,
    genres: ["音乐", "竞技"],
    rating: 8.0,
    heat: 88,
    director: "白承宇",
    cast: ["崔珉赫", "尹诗雅", "郑宇真"],
    duration: "单期110分钟",
    episodes: "全14期",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Energetic%20Korean%20music%20competition%20poster%2C%20young%20performers%20rehearsing%20in%20a%20mirrored%20practice%20room%2C%20dramatic%20amber%20spotlight%20cutting%20through%20deep%20navy%20darkness%2C%20sweat%20and%20motion%20blur%2C%20silhouettes%20of%20dancers%2C%20high%20contrast%20stage%20photography%2C%20bold%20dynamic%20composition%2C%20no%20text&width=600&height=800&seq=rk-poster-21&orientation=portrait",
    tagline: "聚光灯亮起之前，他们已经在黑暗里练了十年。",
    synopsis: "来自不同公司的练习生住进同一栋楼，每周接受一次舞台考核。镜头记录的不只是比赛结果，还有凌晨三点的练习室、受伤的脚踝和不肯放弃的理由。",
    highlights: ["2024年韩国音乐综艺热度前三", "年度最佳舞台设计", "出道组后续专辑销量破百万"]
  },
  {
    id: "solo-izakaya",
    title: "一个人的居酒屋",
    originalTitle: "ひとりの居酒屋",
    type: "variety",
    region: "日本",
    year: 2024,
    genres: ["美食", "真人秀"],
    rating: 8.3,
    heat: 79,
    director: "中村亮",
    cast: ["井上航", "木村彩", "佐藤玲"],
    duration: "单期40分钟",
    episodes: "全10期",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Intimate%20Japanese%20food%20show%20poster%2C%20a%20single%20customer%20seated%20at%20a%20six-seat%20izakaya%20counter%2C%20grilled%20skewers%20and%20a%20small%20cup%20of%20sake%2C%20warm%20amber%20lantern%20light%2C%20deep%20navy%20shadows%2C%20condensation%20on%20glass%2C%20quiet%20solitary%20but%20comforting%20mood%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=600&height=800&seq=rk-poster-22&orientation=portrait",
    tagline: "一个人吃饭，也可以很认真。",
    synopsis: "每期一位客人，独自走进一家只有六个座位的小店。点单、等待、吃完，然后聊几句关于生活的事。没有热闹的配乐，只有烤架的声音和真实的沉默。",
    highlights: ["日本美食节目年度评审推荐", "最佳纪实剪辑提名", "取景店铺预约排至三个月后"]
  },
  {
    id: "street-ballad",
    title: "街头歌谣",
    originalTitle: "거리의 발라드",
    type: "variety",
    region: "韩国",
    year: 2023,
    genres: ["音乐", "治愈"],
    rating: 8.6,
    heat: 81,
    director: "李在容",
    cast: ["朴柱元", "申夏恩", "赵贤宇"],
    duration: "单期65分钟",
    episodes: "全12期",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Street%20music%20documentary%20poster%2C%20a%20busker%20with%20an%20acoustic%20guitar%20performing%20under%20a%20warm%20streetlight%20on%20a%20quiet%20Korean%20sidewalk%20at%20night%2C%20a%20small%20circle%20of%20listeners%2C%20deep%20navy%20shadows%2C%20amber%20glow%2C%20falling%20light%20rain%2C%20intimate%20hopeful%20mood%2C%20candid%20photography%2C%20no%20text&width=600&height=800&seq=rk-poster-23&orientation=portrait",
    tagline: "没有舞台的晚上，歌声反而更清楚。",
    synopsis: "节目组带着一把吉他和一台录音机，走遍韩国十二座小城，寻找在街角唱歌的人。每一期，一首歌和它背后的生活。",
    highlights: ["2023年韩国音乐纪实类最高评分", "年度治愈综艺推荐", "节目歌曲音源逆袭榜单"]
  },
  {
    id: "kyoto-seasons",
    title: "京都四季手帖",
    originalTitle: "京都四季手帖",
    type: "variety",
    region: "日本",
    year: 2025,
    genres: ["纪实", "旅行"],
    rating: 8.9,
    heat: 85,
    director: "森山透",
    cast: ["吉川纱季", "大西悠", "山本千寻"],
    duration: "单期50分钟",
    episodes: "全6期",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Serene%20Japanese%20documentary%20poster%2C%20a%20traditional%20Kyoto%20machiya%20courtyard%20with%20a%20stone%20water%20basin%20and%20maple%20leaves%2C%20soft%20morning%20mist%2C%20moss%20and%20aged%20wood%2C%20deep%20navy%20shadows%20with%20warm%20amber%20highlights%2C%20refined%20quiet%20aesthetic%2C%20vertical%20minimal%20composition%2C%20no%20text&width=600&height=800&seq=rk-poster-24&orientation=portrait",
    tagline: "把一整年，折进一本手帖里。",
    synopsis: "六集节目，六个季节切面。从春日的花见到冬夜的炉火，摄制组跟随三位京都手艺人，记录一座古城如何在四季里缓慢呼吸。",
    highlights: ["2025年日本纪实节目评分第一", "最佳摄影与配乐双提名", "京都文化厅特别推荐"]
  }
];

type MockMedia = {
  id: string;
  title: string;
  originalTitle: string;
  type: "movie" | "tv" | "variety";
  region: "日本" | "韩国";
  year: number;
  genres: string[];
  rating: number;
  heat: number;
  director: string;
  cast: string[];
  duration: string;
  episodes: string;
  status: string;
  cover: string;
  backdrop?: string;
  tagline: string;
  synopsis: string;
  highlights: string[];
  featured?: boolean;
};

export const mediaList = mediaData as MockMedia[];